<template>
  <div class="user-avatar-dropdown">
    <template v-for="(poit, poIdx) in popList">
      <Poptip
        v-if="
          $store.state.user &&
            $store.state.user.btnRole &&
            $store.state.user.btnRole[poit.id]
        "
        :key="poIdx"
        :disabled="poit.total < 1"
        trigger="hover"
        width="400"
        placement="bottom"
      >
        <Badge
          :offset="[14, 0]"
          style="margin-right: 20px"
          :count="poit.total"
          overflow-count="99"
        >
          <a @click="toPage(poit.name)">{{ $t(poit.name) }}</a>
        </Badge>
        <div v-if="poit.total" slot="content">
          <div
            v-for="(item, index) in poit.tableData"
            @click="toPage(item.type, item.feedback_number)"
            :key="index"
            class="msg-ul"
          >
            <div class="msg-top">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.date }}</div>
            </div>
            <div class="msg-li">{{ item.content }}</div>
          </div>
          <!-- <vxe-table
          :row-config="{ isHover: true }"
          max-height="200"
          :data="tableData"
        >
          <vxe-column
            v-for="item in tableCol"
            :width="item.width"
            :key="item.key"
            :field="item.key"
            :title="$t(item.title)"
            @click="toPage(item.id)"
          ></vxe-column>
        </vxe-table> -->
        </div>
      </Poptip>
    </template>
  </div>
</template>

<script>
import { getUserMsg, pushMsg, pushClaimMsg } from "@/api/user";
import { mapState } from "vuex";
export default {
  name: "badge",
  data() {
    return {
      tableCol: [
        {
          title: "zhTitle",
          key: "title",
          width: "200"
        },
        {
          title: "AssistContent",
          key: "content"
        },
        {
          title: "time",
          key: "date",
          width: "130"
        }
      ],
      tableData: [],
      total: 0,
      popList: [
        {
          name: "assistPlatform",
          total: 0,
          id: 530,
          tableData: []
        },
        {
          name: "claim_list",
          total: 0,
          id: 678,
          tableData: []
        }
      ]
    };
  },
  computed: {
    ...mapState({
      remind: state => state.app.remind
    })
  },
  watch: {
    $route() {
      this.getMsg();
    },
    remind(newVal) {
      if (newVal) {
        this.getMsg();
        this.$store.commit("remindFun", false);
      }
    }
  },
  created() {
    // console.log(this.$store.state.user.btnRole);
    this.getMsg();
  },
  methods: {
    getMsg() {
      let that = this;
      getUserMsg().then(res => {
        if (res.data.status) {
          let data = res.data.payload;
          this.popList.forEach((el, idx) => {
            if (data[el.name]) {
              this.$set(this.popList[idx], "total", data[el.name].total);
              this.$set(this.popList[idx], "tableData", data[el.name].rows);
              el.total = data[el.name].total;
            }
          });
        }
      });
      pushMsg().then(res => {
        if (!res.data.status || !res.data.payload) return;
        let data = res.data.payload;
        this.$Notice.config({
          top: 60,
          duration: 5
        });
        this.$Notice.open({
          title: data.title + "    " + data.date,
          render: h => {
            return h("div", [
              h(
                "a",
                {
                  on: {
                    click() {
                      let name = "assistPlatform";
                      if (that.$route.name == "assistPlatform") {
                        that.$store.commit("remindIdFun", data.feedback_number);
                      } else {
                        that.$router.push({
                          params: { id: data.feedback_number },
                          name
                        });
                      }
                    }
                  }
                },
                data.content
              )
            ]);
          }
        });
      });
      pushClaimMsg().then(res => {
        if (!res.data.status || !res.data.payload) return;
        let data = res.data.payload;
        this.$Notice.config({
          top: 60,
          duration: 5
        });
        this.$Notice.open({
          title: "您有一条理赔单需要处理",
          render: h => {
            return h("div", [
              h(
                "a",
                {
                  on: {
                    click() {
                      let name = "claim_list";
                      if (that.$route.name == "claim_list") {
                        that.$store.commit("remindIdFun", data.airway_number);
                      } else {
                        that.$router.push({
                          params: { id: data.airway_number },
                          name
                        });
                      }
                    }
                  }
                },
                data.content
              )
            ]);
          }
        });
      });
    },
    toPage(name, id) {
      // let name = "assistPlatform";
      if (
        (this.$route.name == "assistPlatform" && name == "assistPlatform") ||
        (this.$route.name == "claim_list" && name == "claim_list")
      ) {
        this.$store.commit("remindIdFun", id);
      } else {
        this.$router.push({
          params: { id },
          name
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.msg-ul {
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
  padding: 5px;

  .msg-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      width: 200px;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    // border-bottom: 1px solid #f5f5f5;
  }
  .msg-li {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
</style>
